<template>
  <div class="px-3 py-2">
    <!-- 前置章节 -->
    <div v-if="storyBookId">
      <div class="flex items-center justify-between mt-3">
        <h2 class="text-base font-bold">
          {{ t(`story.setting.prevChapter`) }}
        </h2>
      </div>

      <div class="border border-[#2f2f2f] flex justify-center py-6">
        <div v-if="storyItem" @click="clickSelect">
          <story-list-item class="px-2" :story="storyItem" />
        </div>
        <button v-else class="btn btn-xs rounded" @click="clickSelect">
          {{ t(`story.setting.select`) }}
        </button>
      </div>
    </div>

    <!-- 本章开头 -->
    <div>
      <div class="flex items-center justify-between mt-3">
        <h2 class="text-base font-bold">
          {{ t(`story.setting.chapterStart`) }}
        </h2>

        <div>
          <button
            class="btn btn-xs rounded mr-2"
            v-if="store.form.beginning"
            @click="store.resetOneForm('beginning')"
          >
            {{ t("Buttons.clear") }}
          </button>
          <button
            class="btn btn-xs rounded"
            @click="store.openGenerateModal('beginning')"
          >
            {{ t(`story.auto`) }}
          </button>
        </div>
      </div>

      <VanField
        v-model="store.form.beginning"
        rows="1"
        type="textarea"
        class="mt-2.5"
        :autosize="{ minHeight: 40 }"
      />
    </div>

    <!-- 添加内容节点 -->
    <div class="text-center mt-4" @click="clickAddContent(0)">
      <button class="btn btn-xs rounded">
        {{ t(`story.setting.add`) }}
      </button>
    </div>

    <!-- 内容节点 -->
    <div
      v-for="(content, idx) in store.form.bodyNodezz"
      :key="idx"
      class="w-full"
    >
      <div class="bg-[#3f3f3f] px-4 py-3 rounded-md my-2">
        <div class="flex items-center justify-between">
          <div class="flex">
            <h2 class="text-base font-bold">
              {{ t(`story.setting.node`) }} {{ idx + 1 }}
            </h2>
            <!-- <button
              v-if="!content.beginning && !content.body && !content.ending"
              class="btn  btn-xs rounded mr-1"
              @click="clickGenerate(idx)"
            >
              一键生成
            </button> -->
          </div>
          <div class="flex items-center">
            <button class="btn btn-xs rounded" @click="clickRemoveContent(idx)">
              <i class="iconfont icon-delete text-xs"></i>
            </button>
          </div>
        </div>

        <div class="flex items-center justify-between mt-2">
          <h2>
            {{ t(`story.setting.beginning`) }}
          </h2>
          <div>
            <button
              class="btn btn-xs rounded mr-2"
              v-if="store.form.bodyNodezz![idx].beginning"
              @click="store.resetOneForm('bodyNodezz', idx, 'beginning')"
            >
              {{ t("Buttons.clear") }}
            </button>
            <button
              class="btn btn-xs rounded mr-1"
              @click="store.openGenerateModal('bodyNodezz', idx, 'beginning')"
            >
              {{ t(`story.auto`) }}
            </button>
          </div>
        </div>

        <VanField
          v-model="content.beginning"
          rows="1"
          :autosize="{ minHeight: 40 }"
          type="textarea"
          class="mt-1.5"
        />

        <div class="flex items-center justify-between mt-2">
          <h2>
            {{ t(`story.setting.body`) }}
          </h2>

          <div>
            <button
              class="btn btn-xs rounded mr-2"
              v-if="store.form.bodyNodezz![idx].body"
              @click="store.resetOneForm('bodyNodezz', idx, 'body')"
            >
              {{ t("Buttons.clear") }}
            </button>
            <button
              class="btn btn-xs rounded mr-1"
              @click="store.openGenerateModal('bodyNodezz', idx, 'body')"
            >
              {{ t(`story.auto`) }}
            </button>
          </div>
        </div>
        <VanField
          v-model="content.body"
          rows="1"
          :autosize="{ minHeight: 40 }"
          type="textarea"
          class="mt-1.5"
        />

        <div class="flex items-center justify-between mt-2">
          <h2>
            {{ t(`story.setting.ending`) }}
          </h2>
          <div>
            <button
              class="btn btn-xs rounded mr-2"
              v-if="store.form.bodyNodezz![idx].ending"
              @click="store.resetOneForm('bodyNodezz', idx, 'ending')"
            >
              {{ t("Buttons.clear") }}
            </button>
            <button
              class="btn btn-xs rounded mr-1"
              @click="store.openGenerateModal('bodyNodezz', idx, 'ending')"
            >
              {{ t(`story.auto`) }}
            </button>
          </div>
        </div>
        <VanField
          v-model="content.ending"
          rows="1"
          :autosize="{ minHeight: 40 }"
          type="textarea"
          class="mt-1.5"
        />
      </div>

      <!-- 添加内容节点 -->
      <div class="text-center" @click="clickAddContent(idx + 1)">
        <button class="btn btn-xs rounded">
          {{ t(`story.setting.add`) }}
        </button>
      </div>
    </div>

    <!-- 本章结尾 -->
    <div>
      <div class="flex items-center justify-between mt-3">
        <h2 class="text-base font-bold">{{ t(`story.setting.chapterEnd`) }}</h2>
        <div>
          <button
            class="btn btn-xs rounded mr-2"
            v-if="store.form.ending"
            @click="store.resetOneForm('ending')"
          >
            {{ t("Buttons.clear") }}
          </button>
          <button
            class="btn btn-xs rounded"
            @click="store.openGenerateModal('ending')"
          >
            {{ t(`story.auto`) }}
          </button>
        </div>
      </div>

      <VanField
        v-model="store.form.ending"
        rows="1"
        :autosize="{ minHeight: 40 }"
        type="textarea"
        class="mt-1.5"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import api from "@/modules/api";
import { useStory } from "@/stores/story";
import { useStoryBook } from "@/stores/story-book";
import { storeToRefs } from "pinia";
import { showConfirmDialog, showLoadingToast, showSuccessToast } from "vant";
import { computed } from "vue";
import { onMounted } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import i18n from "@/locales";

const { t } = useI18n();
const route = useRoute();

const store = useStoryBook();
const storyStore = useStory();

const { getStoryEditList } = storeToRefs(storyStore);
const storyBookId = ref(0);

const storyItem = computed(() => {
  return getStoryEditList!.value.find(
    (item) => item.id === store.form.previousStoryId
  );
});

const clickAddContent = (idx: number) => {
  store.form.bodyNodezz!.splice(idx, 0, {
    beginning: "",
    body: "",
    ending: "",
  });
};

const clickRemoveContent = (idx: number) => {
  showConfirmDialog({
    title: i18n.global.t("ConfirmModal.promptTitle"),
    message: i18n.global.t("ConfirmModal.areYouSureDeleteNode"),
    confirmButtonText: i18n.global.t("Buttons.confirm"),
    cancelButtonText: i18n.global.t("Buttons.cancel"),
  })
    .then(() => {
      store.form.bodyNodezz!.splice(idx, 1);
    })
    .catch(() => {});
};

const clickSelect = async () => {
  store.edit.selectChapterType = 1;
  store.edit.selectChapterId = store.form.previousStoryId || 0;
  store.edit.showSelectChapter = true;
  store.edit.chapterLoading = true;
  store.edit.isShowStoryBook = false;
  try {
    await storyStore.getEditStoryList(storyBookId.value);
  } catch (e) {}
  store.edit.chapterLoading = false;
};

// let loading: any;
// const clickGenerate = async (idx: number) => {
//   loading = showLoadingToast({ message: "生成中..." });
//   autoGenerate(idx, 0);
// };

// function autoGenerate(idx: number, gIdx: number) {
//   const params = JSON.parse(JSON.stringify(store.form));
//   const { bodyNodezz } = params;
//   const list = ["beginning", "body", "ending"];
//   const node = bodyNodezz![idx];
//   const item = list[gIdx];
//   if (node[item]) {
//     if (gIdx !== 2) autoGenerate(idx, gIdx + 1);
//     return;
//   }
//   loading.message = `${Number(gIdx) + 1}/3\n生成${t(
//     `story.setting.${item}`
//   )}中...`;
//   node[item] += `"""请在这里补全内容"""`;
//   api.storyWriteGenerate(params, callback);
//   function callback(text: string) {
//     if (typeof text === "object") {
//       // 传输完了
//       if (gIdx !== 2) autoGenerate(idx, gIdx + 1);
//       else {
//         loading.close();
//         showSuccessToast({ message: "生成成功" });
//       }
//       return;
//     }
//     store.form.bodyNodezz![idx][item] += text as any;
//     node[item] += text;
//   }
// }

onMounted(() => {
  const { id } = route.query;
  if (id) storyBookId.value = Number(id);
});
</script>
